module.exports = __webpack_public_path__ + "fonts/OpenSans-LightItalic.c2e4b546.eot";